import { apiGet, apiPatch, apiPost } from "@/shared/api";

/**
 * Agente Claude in Messaggi (Davide 30/10/2026: «mettiamo agente haiku nei
 * messaggi»). Legge la conversazione, l'ordine, il tracking e il manuale di OM
 * con gli strumenti del connettore e propone una bozza. Non salva e non invia
 * niente: la bozza va nella casella, l'invio resta all'operatore.
 */
export type Turno = { ruolo: "operatore" | "claude"; testo: string };

export type RispostaAgente = {
  testo: string;
  bozza: string | null;
  bozza_motivo: string | null;
};

export type StatoAgente = {
  modello: string;
  spesa_mese_usd: string;
  tetto_mese_usd: string;
  /** Bozze degli ultimi 30 giorni: uguale, ritoccata, riscritta, non_inviata, sostituita. */
  bozze_30_giorni: Record<string, number>;
};

export function chiediAgente(
  threadId: number,
  domanda: string,
  storia: Turno[],
): Promise<RispostaAgente> {
  return apiPost<RispostaAgente>(`/api/mail/threads/${threadId}/agente`, { domanda, storia });
}

export function statoAgente(): Promise<StatoAgente> {
  return apiGet<StatoAgente>("/api/mail/agente/stato");
}

/** Bozza preparata all'arrivo del messaggio (lane ``agente_bozze``). Mai inviata da sola. */
export type BozzaPronta = {
  testo: string;
  tipo: string | null;
  modello: string | null;
  creato_il: string;
};

export function bozzaPronta(threadId: number): Promise<BozzaPronta | null> {
  return apiGet<BozzaPronta | null>(`/api/mail/threads/${threadId}/agente/pronta`);
}

export type StatoRegola = "proposta" | "approvata" | "rifiutata" | "spenta";

/** Regola di Kery per le risposte: nel prompt solo le ``approvata``. Decide Davide. */
export type Regola = {
  id: number;
  testo: string;
  stato: StatoRegola;
  motivo: string;
  proposta_da: string;
  creato_il: string;
  deciso_il: string | null;
};

export function regoleAgente(): Promise<Regola[]> {
  return apiGet<Regola[]>("/api/mail/agente/regole");
}

export function nuovaRegola(testo: string): Promise<Regola> {
  return apiPost<Regola>("/api/mail/agente/regole", { testo });
}

export function decidiRegola(id: number, stato: StatoRegola): Promise<Regola> {
  return apiPatch<Regola>(`/api/mail/agente/regole/${id}`, { stato });
}
